import { z } from 'zod';

export const campaignSchema = z.object({
  firstName: z.string().trim().min(1, 'Enter your first name').max(80, 'Use 80 characters or fewer'),
  lastName: z.string().trim().min(1, 'Enter your last name').max(80, 'Use 80 characters or fewer'),
  email: z.string().trim().email('Enter a valid email address'),
  mobile: z.string().trim().regex(/^\+?[\d\s().-]+$/, 'Enter a valid mobile number')
    .refine(value => { const digits = value.replace(/\D/g, ''); return digits.length >= 10 && digits.length <= 15; }, 'Enter a mobile number with 10–15 digits'),
});
